import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { ButtonSizeType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT, FONT_FAMILY) => ({
    rootContainer: {
        row_gap: FOUNDATIONS.spacing_150,
    },
    titleTooltipContainer: {
        display: 'flex',
        flex_direction: 'row',
        justify_content: 'space-between',
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    tooltipIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_default_secondary_icon_100,
    },
    // TODO add when is created TooltipVariantType
    // tooltip: {
    //   variant: 'DEFAULT',
    // },
    animationInputsContainer: {
        position: 'relative',
    },
    inputDigitsContainer: {
        column_gap: FOUNDATIONS.spacing_150,
    },
    inputDigitAndNumberContainer: {
        width: '100%',
        row_gap: FOUNDATIONS.spacing_100,
        flex_direction: 'column-reverse',
    },
    inputDigitContainer: {
        opacity: '1',
        width: '100%',
        min_width: '100%',
        max_width: '100%',
        height: FOUNDATIONS.size_425,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        border_radius: FOUNDATIONS.radius_comp_forms_inputdigitsequence_radiussize,
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_neutral_border_50,
        box_shadow: `0px 0px 0px 0px ${FOUNDATIONS.color_accent_active_animation_border_50}`,
        transition: 'box-shadow 250ms ease-in',
    },
    inputDigitContainerError: {
        background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
        border_width: FOUNDATIONS.border_100,
        border_color: FOUNDATIONS.color_feedback_error_border_50,
    },
    inputDigitContainerfocus: {
        border_width: FOUNDATIONS.border_100,
        border_color: FOUNDATIONS.color_accent_active_primary_border_50,
        box_shadow: `0px 0px 0px ${FOUNDATIONS.border_150} ${FOUNDATIONS.color_accent_active_animation_border_50}`,
    },
    inputDigitText: {
        font_size: FONT.font_paragraph_50[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_paragraph_50[DeviceBreakpointsType.DESKTOP].line_height,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    inputDigitTextTypePassword: {
        font_family: FONT_FAMILY.font_family_digit_password_circle,
    },
    inputNumber: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        // Needed for the label effect
        line_height: FONT.font_paragraph_350[DeviceBreakpointsType.DESKTOP].line_height,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    errorContainer: {
        gap: FOUNDATIONS.spacing_100,
        align_items: 'center',
    },
    errorText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_feedback_error_font_50,
    },
    errorIcon: {
        width: FOUNDATIONS.size_150,
        height: FOUNDATIONS.size_150,
    },
    helpTextContainer: {},
    helpText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
    },
    actionButtonSize: ButtonSizeType.EXTRA_SMALL,
});
//# sourceMappingURL=commonStyles.js.map